type AttachmentFileKind = 'image' | 'pdf' | 'document' | 'spreadsheet' | 'text' | 'code' | 'archive' | 'file';

const FILE_TYPES: Record<AttachmentFileKind, { kind: AttachmentFileKind; label: string; icon: string }> = {
  image: { kind: 'image', label: 'IMG', icon: 'file-image' },
  pdf: { kind: 'pdf', label: 'PDF', icon: 'file-text' },
  document: { kind: 'document', label: 'DOC', icon: 'file-text' },
  spreadsheet: { kind: 'spreadsheet', label: 'XLS', icon: 'file-spreadsheet' },
  text: { kind: 'text', label: 'TXT', icon: 'file-type' },
  code: { kind: 'code', label: 'JSON', icon: 'file-code' },
  archive: { kind: 'archive', label: 'ZIP', icon: 'file-archive' },
  file: { kind: 'file', label: '', icon: 'file' },
};

const EXTENSION_KINDS: Record<string, AttachmentFileKind> = {
  png: 'image', jpg: 'image', jpeg: 'image', webp: 'image', gif: 'image', heic: 'image', heif: 'image',
  pdf: 'pdf', doc: 'document', docx: 'document', odt: 'document',
  xls: 'spreadsheet', xlsx: 'spreadsheet', ods: 'spreadsheet', csv: 'spreadsheet',
  txt: 'text', json: 'code', zip: 'archive', rar: 'archive', '7z': 'archive',
};

export function getTransactionAttachmentFileType(contentType: string, fileName: string) {
  const mimeType = contentType.split(';')[0].trim().toLowerCase();
  const extension = fileName.includes('.') ? fileName.split('.').pop()!.toLowerCase() : '';
  const extensionKind = Object.hasOwn(EXTENSION_KINDS, extension) ? EXTENSION_KINDS[extension] : undefined;
  let kind: AttachmentFileKind = 'file';
  if (mimeType.startsWith('image/')) kind = 'image';
  else if (mimeType === 'application/pdf') kind = 'pdf';
  else if (/spreadsheet|excel|opendocument\.spreadsheet/.test(mimeType) || mimeType === 'text/csv') {
    kind = 'spreadsheet';
  } else if (/msword|wordprocessingml|opendocument\.text/.test(mimeType)) kind = 'document';
  else if (mimeType === 'application/json') kind = 'code';
  else if (mimeType.startsWith('text/')) kind = 'text';
  else if (/zip|rar|7z-compressed/.test(mimeType)) kind = 'archive';
  else if (!mimeType || mimeType === 'application/octet-stream') kind = extensionKind ?? 'file';

  const fileType = FILE_TYPES[kind];
  return {
    ...fileType,
    label: extensionKind === kind ? extension.toUpperCase() : fileType.label,
  };
}

export function isPreviewableTransactionAttachment(contentType: string) {
  return contentType.startsWith('image/')
    || contentType.startsWith('text/')
    || contentType === 'application/json'
    || contentType === 'application/pdf';
}

export function getTransactionAttachmentPreviewContentType(contentType: string) {
  return contentType.startsWith('text/') || contentType === 'application/json'
    ? 'text/plain;charset=utf-8'
    : contentType;
}
